import React from 'react';
import { CTAButton } from './CTAButton';
import { MockupImage } from './MockupImage';
import { TrustLine } from './TrustLine';
import { CHECKOUT_URL, PRICE, PRODUCT, PRODUCT_TAGLINE } from '../data/constants';
export function FinalCTA() {
  return <section className="border-t-4 border-tech bg-white py-5 sm:py-7" data-id="element-44" data-mp="c83pjkbwtm5j">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-45" data-mp="84e24y6z1am3">
        <h2 className="text-center text-2xl leading-tight text-navy sm:text-4xl" data-id="element-46" data-mp="m4ykjt8z54f2">
          UNE DERNIÈRE <span className="text-tech" data-id="element-47" data-mp="h5vdk39foo4g">QUESTION</span>
        </h2>
        <div className="mx-auto mt-1.5 max-w-3xl space-y-1 text-center text-sm leading-snug text-steel sm:text-base" data-id="element-48" data-mp="h5lnkfoe2gyr">
          <p data-id="element-49" data-mp="vwkt1htxgpe4">Combien de fois avez-vous remplacé une pièce en espérant que la panne disparaisse…</p>
          <p data-id="element-50" data-mp="qy15jczor5jn">
            <strong className="font-semibold text-navy" data-id="element-51" data-mp="14vg1l0kg2bkl">
              sans avoir vraiment confirmé la cause par une mesure ?
            </strong>
          </p>
          <p data-id="element-52" data-mp="zxy17ykht4o7">
            Vous pouvez continuer à chercher dans des forums, des notes et des vidéos dispersées.
            Ou ouvrir un seul système professionnel organisé.
          </p>
          <p data-id="element-53" data-mp="2h4j0ywvdbqpo">
            <strong className="font-semibold text-navy" data-id="element-54" data-mp="2h3zuccb64oqy">
              Observer. Lire. Mesurer. Puis valider.
            </strong>
          </p>
        </div>

        <MockupImage className="mt-2" data-id="element-55" data-mp="2r278kne2osp9" />

        <div className="mt-2 text-center" data-id="element-56" data-mp="2r38jmrv39f6z">
          <p className="font-heading text-xl font-extrabold uppercase leading-tight text-navy sm:text-3xl" data-id="element-57" data-mp="2v3sji371qwwt">
            🔧 {PRODUCT}
          </p>
          <p className="mx-auto mt-1 max-w-2xl font-display text-xs font-semibold uppercase leading-tight tracking-wide text-steel sm:text-base" data-id="element-58" data-mp="30111a2oa8yxj">
            {PRODUCT_TAGLINE}
          </p>
          <p className="mt-1 font-display text-2xs font-bold uppercase tracking-wide text-tech sm:text-sm" data-id="element-59" data-mp="39r3ti0nky8ut">
            OBD-II • Moteur • Électricité • Transmission • Freinage • Méthodes atelier
          </p>
        </div>

        <div className="mt-3 flex flex-col items-center" data-id="element-60" data-mp="3ir0kwa1ctltk">
          <p className="mb-2 text-center font-display text-base font-extrabold uppercase leading-tight text-navy sm:text-xl" data-id="element-61" data-mp="1jpelxizwhgvo">
            🔥 OBTENEZ LE SYSTÈME COMPLET AUJOURD’HUI — <span className="text-tech" data-id="element-62" data-mp="1sgeww7s7i84p">{PRICE}</span>
          </p>
          <CTAButton href={CHECKOUT_URL} data-id="element-63" data-mp="1sirn1884bosu">🔧 OUI ! JE VEUX {PRODUCT}</CTAButton>
          <TrustLine items={['Accès immédiat • Livraison numérique', '🛡️ Garantie de 7 jours']} data-id="element-64" data-mp="1nodo4vu8yzjf" />
        </div>
      </div>
    </section>;
}